module.exports = __webpack_public_path__ + "static/media/snooze.4a9b75a4.svg";